<footer class="flex">
  <div>
    <strong>Copyright</strong> EON &copy; 2020
  </div>
  <div class="flex-fill"></div>
  <div>
    <span style="color: #888">Likron Web Platform</span>
  </div>
</footer>
